import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FirmaItem } from './firma.model';
import {CollectionApiResponse} from '../../../lib/util/api-response';
import {FirmaZeitItem} from '@src/app/pages/Mitarbeiterverwaltung/firmaZeit.model';
import {FeiertagItem} from '@src/app/pages/Mitarbeiterverwaltung/feiertage.model';

type Firma = CollectionApiResponse<FirmaItem>;
type FirmaZeiten = CollectionApiResponse<FirmaZeitItem>;
type Feiertage = CollectionApiResponse<FeiertagItem>;

@Injectable()
export class FirmaService {
    /**
     * Constructor of address service
     *
     * @param http - The http client
     */
    constructor(private http: HttpClient) {}

    /**
     * Returns a list of addresses
     *
     * @returns - An observable that emits the response
     */
    public getFirma(): Observable<FirmaItem> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/getFirma.php?${sessionStorage.getItem('session')}`) as Observable<
        FirmaItem
        >;
    }

  public getFeiertage(firmaZeitId: number): Observable<Feiertage> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/getFeiertage.php?${sessionStorage.getItem('session')}&firmaZeit=${firmaZeitId}`) as Observable<
      Feiertage
      >;
  }

  public getFirmaZeiten(): Observable<FirmaZeiten> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/getFirmaZeiten.php?${sessionStorage.getItem('session')}`) as Observable<
      FirmaZeiten
      >;
  }

  public addFirmaZeit(): Observable<number> {
    // eslint-disable-next-line max-len
    return this.http.get(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/addFirmaZeit.php?${sessionStorage.getItem('session')}`,
    ) as Observable<number>;
  }

  public addFeiertage(feiertag: FeiertagItem): Observable<FeiertagItem> {
    // eslint-disable-next-line max-len
    return this.http.post(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/addFeiertage.php?${sessionStorage.getItem('session')}`, feiertag) as Observable<FeiertagItem>;
  }

  public editFeiertage(feiertag: FeiertagItem): Observable<FeiertagItem> {
    // eslint-disable-next-line max-len
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/editFeiertage.php?${sessionStorage.getItem('session')}`, feiertag) as Observable<FeiertagItem>;
  }

  public deleteFeiertage(feiertag: FeiertagItem): Observable<FeiertagItem> {
      console.log(feiertag);
    // eslint-disable-next-line max-len
      return this.http.delete(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/deleteFeiertage.php?${sessionStorage.getItem('session')}&feiertagId=${feiertag.id}&firmaZeitId=${feiertag.firmaZeitId}`) as Observable<FeiertagItem>;
      }

  public editFirmaZeit(firmaZeit: FirmaZeitItem): Observable<FirmaZeitItem> {
    // eslint-disable-next-line max-len
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/editFirmaZeit.php?${sessionStorage.getItem('session')}`,
      firmaZeit,
    ) as Observable<FirmaZeitItem>;
  }

  public deleteFirmaZeit(firmaZeitId: number): Observable<number> {
    // eslint-disable-next-line max-len
    return this.http.delete(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/deleteFirmaZeit.php?${sessionStorage.getItem('session')}&firmaZeitId=${firmaZeitId}`,
    ) as Observable<number>;
  }

  public edit(firma: FirmaItem): Observable<FirmaItem> {
    // eslint-disable-next-line max-len
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/editFirma.php?${sessionStorage.getItem('session')}`,
      firma,
    ) as Observable<FirmaItem>;
  }

}
